import VisitorData from '../helpers/visitor-data';

export default function screenOrientationDimension(): void {
    const orientation = VisitorData.getDeviceOrientation();

    if (orientation.type) {
        Analytics.set('orientation', orientation.type);
    }
}
